import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import store from './store'
import 'babel-polyfill'
import 'common/styl/index.styl'
import api from 'api'
import Element from 'element-ui'
import 'common/theme/index.css'
import * as filters from './filter/filter'
import MetaInfo from 'vue-meta-info'
import 'config/flexible' // 移动端适配修改依赖flexible.js
// import 'lib-flexible'
// import './data.js'
Vue.use(MetaInfo)
Vue.use(Vuex)
Vue.use(Element)
Vue.config.productionTip = false
Vue.prototype.api = api
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>',
  data: {
    eventHub: new Vue()
  }
})

var _hmt = window._hmt || []
router.beforeEach((to, from, next) => {
  // 统计代码
  if (to.path) {
    _hmt.push(['_trackPageview', '/#' + to.fullPath])
  }
  next()
})



// WEBPACK FOOTER //
// ./src/main.js